function PayQuoteDatepicker() {
	$('.js-pq-datepicker').datepicker(); 
}

export { PayQuoteDatepicker };